import { WithAvailabilityBlockId, WithServiceId } from '@mews-commander/types';
import { DataTestId } from '@mews-commander/enums';
import { WithFormArrayFields } from '../../../../types';
import { ReadOnlyCell } from '../Cells/AsideCells/ReadOnlyCell';
import { BlockSetUpAsideWrapperRow, BlockSetUpAsideWrapperTotalRow } from '../Cells/styles';
import { EditableCell } from '../Cells/AsideCells/EditableCell';
import AsideTotalCell from '../Cells/AsideCells/AsideTotalCell';

interface RenderAsideParams extends WithServiceId, WithFormArrayFields, WithAvailabilityBlockId {
    isEditingAvailability: boolean;
    initialResourceCategories: Array<string>;
}

export const renderAside = ({
    fields,
    isEditingAvailability,
    serviceId,
    availabilityBlockId,
    initialResourceCategories,
}: RenderAsideParams) =>
    fields
        .map((field, index) => (
            <BlockSetUpAsideWrapperRow key={field.id} data-test-id={DataTestId.SpaceCategory}>
                {isEditingAvailability ? (
                    <EditableCell
                        serviceId={serviceId}
                        availabilityBlockId={availabilityBlockId}
                        initialResourceCategories={initialResourceCategories}
                        index={index}
                        fields={fields}
                    />
                ) : (
                    <ReadOnlyCell index={index} serviceId={serviceId} />
                )}
            </BlockSetUpAsideWrapperRow>
        ))
        .concat(
            <BlockSetUpAsideWrapperTotalRow key="block-setup-editable-aside-total-row">
                <AsideTotalCell
                    availabilityBlockId={availabilityBlockId}
                    isEditingAvailability={isEditingAvailability}
                />
            </BlockSetUpAsideWrapperTotalRow>
        );
